<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {RepeatInterval} from "@/modules/redactor/models/guard/RepeatInterval";

export default {
  name: "r-repeat-interval",
  props: {
    model: VueTypes.instanceOf(RepeatInterval),
    label: VueTypes.string.def("Repeat Interval")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return RepeatInterval.getValues();
    }
  }
}
</script>